import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Results from "./pages/Results";
import SalesProof from "./pages/SalesProof";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes with Header/Footer */}
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/about" element={<><Header /><About /><Footer /></>} />
          <Route path="/services" element={<><Header /><Services /><Footer /></>} />
          <Route path="/results" element={<><Header /><Results /><Footer /></>} />
          <Route path="/salesproof" element={<><Header /><SalesProof /><Footer /></>} />
          <Route path="/blog" element={<><Header /><Blog /><Footer /></>} />
          <Route path="/blog/:slug" element={<><Header /><BlogPost /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          
          {/* Admin routes without Header/Footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
